import { jsx as _jsx } from "react/jsx-runtime";
import { TourTrackingContext } from 'ui-shepherd-react/contexts/TourTrackingContext';
import { TourUsageTracker } from '../usageTracker';
export const TourTrackingProvider = ({
  appName,
  children
}) => {
  const usageTracker = new TourUsageTracker(appName);
  return /*#__PURE__*/_jsx(TourTrackingContext.Provider, {
    value: {
      appName,
      usageTracker
    },
    children: children
  });
};